/**
 * Somatus Hybrid Scheduler API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AppointmentType } from '../model/appointmentType';
import { ConfigurationResponseModel } from '../model/configurationResponseModel';
import { HsappointmentModeMasterModel } from '../model/hsappointmentModeMasterModel';
import { HstimeZoneMasterModel } from '../model/hstimeZoneMasterModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ReferenceDataService {

    protected basePath = 'http://localhost:5001/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public referenceDataGetAppointmentModes(observe?: 'body', reportProgress?: boolean): Observable<Array<HsappointmentModeMasterModel>>;
    public referenceDataGetAppointmentModes(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<HsappointmentModeMasterModel>>>;
    public referenceDataGetAppointmentModes(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<HsappointmentModeMasterModel>>>;
    public referenceDataGetAppointmentModes(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<HsappointmentModeMasterModel>>('get',`${this.basePath}/api/ReferenceData/appointment-modes`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public referenceDataGetAppointmentTypes(observe?: 'body', reportProgress?: boolean): Observable<Array<AppointmentType>>;
    public referenceDataGetAppointmentTypes(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AppointmentType>>>;
    public referenceDataGetAppointmentTypes(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AppointmentType>>>;
    public referenceDataGetAppointmentTypes(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<AppointmentType>>('get',`${this.basePath}/api/ReferenceData/appointment-types`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public referenceDataGetConfigurations(observe?: 'body', reportProgress?: boolean): Observable<Array<ConfigurationResponseModel>>;
    public referenceDataGetConfigurations(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ConfigurationResponseModel>>>;
    public referenceDataGetConfigurations(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ConfigurationResponseModel>>>;
    public referenceDataGetConfigurations(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ConfigurationResponseModel>>('get',`${this.basePath}/api/ReferenceData/configurations`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public referenceDataGetTimeZoneList(observe?: 'body', reportProgress?: boolean): Observable<Array<HstimeZoneMasterModel>>;
    public referenceDataGetTimeZoneList(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<HstimeZoneMasterModel>>>;
    public referenceDataGetTimeZoneList(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<HstimeZoneMasterModel>>>;
    public referenceDataGetTimeZoneList(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<HstimeZoneMasterModel>>('get',`${this.basePath}/api/ReferenceData/timezones`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public referenceDataGetVersion(observe?: 'body', reportProgress?: boolean): Observable<string>;
    public referenceDataGetVersion(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public referenceDataGetVersion(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public referenceDataGetVersion(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<string>('get',`${this.basePath}/api/ReferenceData/version`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
